import axios from "axios";

import { IP } from "../utils/Host";


export function updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa(drop_grupa_global_id,nowy_koniec,refreshGantAll) {

// id = procesor id

  axios.get(IP + "zmienCzasTrwaniaGrupyOprawa/"+drop_grupa_global_id+"/"+nowy_koniec+"/" + sessionStorage.getItem("token"))
    .then((res) => {
            console.log("Oprawa przerwa Gant")
      console.log("drop_grupa_global_id"+drop_grupa_global_id)
      console.log("nowy_koniec"+nowy_koniec)
    // console.log("procesor " +res.data[0].mcr)
    // fechparametryTechnologii
       refreshGantAll()

    });
}
